import React from 'react';
import MaterialTableContainer, {
    TableContainerProps as MaterialTableContainerProps,
} from '@mui/material/TableContainer';
import styled from 'styled-components';

const StyledTableContainer = styled(MaterialTableContainer)``;

export type TableContainerProps = MaterialTableContainerProps & {};

const TableContainer: React.FunctionComponent<TableContainerProps> = ({ children, ...props }) => {
    return <StyledTableContainer {...props}>{children}</StyledTableContainer>;
};

export default TableContainer;
